import { render, staticRenderFns } from "./CarCategoryList.vue?vue&type=template&id=3067f50e&scoped=true&"
import script from "./CarCategoryList.vue?vue&type=script&lang=js&"
export * from "./CarCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CarCategoryList.vue?vue&type=style&index=0&id=3067f50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067f50e",
  null
  
)

export default component.exports